'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Seq } from 'immutable';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import { getAvailableDates as getAvailableDatesSelector, isSelectedDateAvailable as getIsSelectedDateAvailable } from 'MeetingsLib/selectors/AvailabilitySelectors';
import { getIsFetchingPublicAvailability, getIsFetchingOwnerPublicAvailability } from 'MeetingsLib/selectors/RequestStatusSelectors';
export default (function (WrappedComponent) {
  var EnsureAvailableDate = createReactClass({
    displayName: "EnsureAvailableDate(" + WrappedComponent.displayName + ")",
    propTypes: {
      isSelectedDateAvailable: PropTypes.bool,
      compact: PropTypes.bool,
      setEventDate: PropTypes.func.isRequired,
      availableDateOptions: PropTypes.instanceOf(Seq).isRequired,
      isFetchingPublicAvailability: PropTypes.bool.isRequired,
      isFetchingPublicOwnerAvailability: PropTypes.bool.isRequired
    },
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
      var _this$props = this.props,
          compact = _this$props.compact,
          availableDateOptions = _this$props.availableDateOptions,
          isSelectedDateAvailable = _this$props.isSelectedDateAvailable,
          setEventDate = _this$props.setEventDate;

      if (!compact && !isSelectedDateAvailable) {
        setEventDate(availableDateOptions.min());
      }
    },
    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props2 = this.props,
          publicAvailabilityWasLoading = _this$props2.isFetchingPublicAvailability,
          ownerAvailabilityWasLoading = _this$props2.isFetchingPublicOwnerAvailability,
          compact = _this$props2.compact;
      var publicAvailabilityLoading = nextProps.isFetchingPublicAvailability,
          ownerAvailabilityLoading = nextProps.isFetchingPublicOwnerAvailability,
          isSelectedDateAvailable = nextProps.isSelectedDateAvailable,
          availableDateOptions = nextProps.availableDateOptions,
          setEventDate = nextProps.setEventDate;
      var publicWasLoading = publicAvailabilityWasLoading && !publicAvailabilityLoading;
      var publicOwnerWasLoading = ownerAvailabilityWasLoading && !ownerAvailabilityLoading;

      if (publicWasLoading || publicOwnerWasLoading) {
        if (!compact && !isSelectedDateAvailable) {
          setEventDate(availableDateOptions.min());
        }
      }
    },
    render: function render() {
      var _this$props3 = this.props,
          __isSelectedDateAvailable = _this$props3.isSelectedDateAvailable,
          __availableDateOptions = _this$props3.availableDateOptions,
          __isFetchingPublicAvailability = _this$props3.isFetchingPublicAvailability,
          __isFetchingPublicOwnerAvailability = _this$props3.isFetchingPublicOwnerAvailability,
          otherProps = _objectWithoutProperties(_this$props3, ["isSelectedDateAvailable", "availableDateOptions", "isFetchingPublicAvailability", "isFetchingPublicOwnerAvailability"]);

      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, otherProps));
    }
  });
  return connect(function (state) {
    return {
      isSelectedDateAvailable: getIsSelectedDateAvailable(state),
      availableDateOptions: getAvailableDatesSelector(state),
      isFetchingPublicAvailability: getIsFetchingPublicAvailability(state),
      isFetchingPublicOwnerAvailability: getIsFetchingOwnerPublicAvailability(state)
    };
  })(EnsureAvailableDate);
});